export interface DatePickerDisplayValueInput {
  value?: string
  placeholder?: string
}

export function getDatePickerDisplayValue({ value, placeholder }: DatePickerDisplayValueInput): string {
  return value || placeholder || ''
}
